// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let IconV5 = require("../../uikit/atoms/Icon/IconV5.bs.js");
let MarkupHelpers = require("../../reason/common/MarkupHelpers/MarkupHelpers.bs.js");
let Stdlib_Option = require("@rescript/runtime/lib/js/Stdlib_Option.js");
let Primitive_option = require("@rescript/runtime/lib/js/Primitive_option.js");
let JsxRuntime = require("react/jsx-runtime");
let VerifiedAgentCardV5 = require("./VerifiedAgentCardV5.bs.js");
let RescriptRelay_Fragment = require("rescript-relay/src/RescriptRelay_Fragment.bs.js");
let RemovedSharedPropertyV5_removedSharedProperty_graphql = require("../../__generated__/RemovedSharedPropertyV5_removedSharedProperty_graphql.bs.js");

let convertFragment = RemovedSharedPropertyV5_removedSharedProperty_graphql.Internal.convertFragment;

function waitForFragmentData(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, RemovedSharedPropertyV5_removedSharedProperty_graphql.node, convertFragment, fRef);
}

function use(fRef) {
  return RescriptRelay_Fragment.useFragment(RemovedSharedPropertyV5_removedSharedProperty_graphql.node, convertFragment, fRef);
}

function useOpt(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Primitive_option.some(Primitive_option.valFromOption(fRef)) : undefined, RemovedSharedPropertyV5_removedSharedProperty_graphql.node, convertFragment);
}

function readResolverFragment(fRef) {
  return RescriptRelay_Fragment.read(RemovedSharedPropertyV5_removedSharedProperty_graphql.node, convertFragment, fRef);
}

let Fragment = {
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment,
  waitForFragmentData: waitForFragmentData,
  use: use,
  useOpt: useOpt,
  readResolverFragment: readResolverFragment
};

function RemovedSharedPropertyV5(props) {
  let match = RescriptRelay_Fragment.useFragment(RemovedSharedPropertyV5_removedSharedProperty_graphql.node, convertFragment, props.removedSharedProperty);
  let sender = match.sender;
  return JsxRuntime.jsxs(MarkupHelpers.Container.make, {
    children: [
      JsxRuntime.jsx("div", {
        children: JsxRuntime.jsxs("div", {
          children: [
            JsxRuntime.jsx("div", {
              children: JsxRuntime.jsx(IconV5.make, {
                icon: "attention-alt",
                size: 60,
                className: "text-tan-biscay"
              }),
              className: "pl-4 pr-6"
            }),
            JsxRuntime.jsx("div", {
              children: JsxRuntime.jsxs("div", {
                children: [
                  JsxRuntime.jsx("h3", {
                    children: "This property is no longer available",
                    className: "text-lg font-medium leading-6 text-gray-900"
                  }),
                  JsxRuntime.jsx("div", {
                    children: "The property has been removed from TAN. For more information, please contact your agent.",
                    className: "mt-2 text-gray-500"
                  })
                ],
                className: "mb-6"
              })
            })
          ],
          className: "flex flex-row"
        }),
        className: "content-box p-4 mt-6 border rounded"
      }),
      sender !== undefined ? JsxRuntime.jsx("div", {
          children: JsxRuntime.jsx("div", {
            children: JsxRuntime.jsx(VerifiedAgentCardV5.make, {
              chapter: Stdlib_Option.map(match.chapter, c => c.fragmentRefs),
              agent: sender.fragmentRefs
            }),
            className: "container py-6"
          }),
          className: "bg-white h-full mt-6"
        }) : null
    ]
  });
}

let make = RemovedSharedPropertyV5;

exports.Fragment = Fragment;
exports.make = make;
/* IconV5 Not a pure module */
